(() => {
  const api = {
    isSoldOut: (variant) => Boolean(variant?.tracked && variant.quantity <= 0),
    async request(id, email, transport = fetch) {
      const response = await transport('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YccTBY', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-10-15' },
        body: JSON.stringify({ data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: { data: { type: 'profile', attributes: { email: email.trim() } } }, channels: ['EMAIL'] },
          relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${id}` } } }
        } })
      });
      if (response.status !== 202) throw new Error('restock_request_failed');
    }
  };
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof customElements === 'undefined' || customElements.get('materik-restock')) return;

  customElements.define('materik-restock', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-restock-config]').textContent);
      this.host = this.closest('product-info');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-restock-form]');
      this.trigger = this.querySelector('[data-restock-trigger]');
      this.status = this.querySelector('[data-restock-status]');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.busy = false;
      this.submitted = new Set();
      this.trigger.addEventListener('click', () => this.open(this.currentVariant()));
      this.querySelector('[data-restock-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.previousFocus?.focus());
      this.form.addEventListener('submit', (event) => this.submit(event));
      document.body.append(this.dialog);
      this.guard = (event) => {
        if (!event.target.matches('form[data-type="add-to-cart-form"]') || !this.eligible(this.currentVariant())) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(this.currentVariant());
      };
      this.host.addEventListener('submit', this.guard, true);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.host, { attributes: true, subtree: true, attributeFilter: ['value', 'data-model-ready'] });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === String(this.host.dataset.section)) this.sync();
      });
      this.sync();
      const params = new URL(location.href).searchParams;
      if (window.Shopify?.theme?.role !== 'main' && params.get('restock_preview') === '1') {
        this.open(this.config.variants.find((variant) => variant.id === params.get('variant')));
      }
    }

    disconnectedCallback() {
      this.dialog?.remove();
      this.observer?.disconnect();
      this.unsubscribe?.();
      this.host?.removeEventListener('submit', this.guard, true);
      this.host?.removeAttribute('data-restock-unavailable');
    }

    currentVariant() {
      const id = this.host.querySelector('product-form input[name="id"]')?.value;
      return this.config.variants.find((variant) => variant.id === String(id));
    }

    eligible(variant) {
      return api.isSoldOut(variant);
    }

    sync() {
      const selection = this.host.modelSelection;
      const chosen = !selection || (!selection.pending && selection.matches());
      const show = chosen && this.eligible(this.currentVariant());
      this.host.toggleAttribute('data-restock-unavailable', Boolean(show));
      this.trigger.hidden = !show;
    }

    open(variant) {
      if (!this.eligible(variant)) return;
      this.activeVariant = variant;
      this.previousFocus = document.activeElement;
      this.dialog.querySelector('[data-restock-variant]').textContent = variant.title;
      const image = this.dialog.querySelector('[data-restock-image]');
      image.src = variant.image;
      image.alt = `${this.config.productTitle}, ${variant.title}`;
      this.status.textContent = '';
      this.form.hidden = false;
      this.submitButton.disabled = this.busy;
      if (!this.dialog.open) this.dialog.showModal();
      this.form.querySelector('input[type="email"]').focus();
    }

    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const variant = this.activeVariant;
      const email = this.form.querySelector('input[type="email"]').value.trim();
      const key = `${variant.id}:${email.toLowerCase()}`;
      if (this.submitted.has(key)) {
        this.status.textContent = this.config.success;
        this.form.hidden = true;
        return;
      }
      this.busy = true;
      this.submitButton.disabled = true;
      this.status.textContent = this.config.sending;
      try {
        await api.request(variant.id, email);
        this.submitted.add(key);
        this.status.textContent = this.config.success;
        this.form.hidden = true;
      } catch {
        this.status.textContent = this.config.error;
      } finally {
        this.busy = false;
        this.submitButton.disabled = false;
      }
    }
  });
})();
